<template>
    <div :style="cssVars">
        <div class="column">
            <h1>{{ settings.title }}</h1>
            <h3 v-if="!settings.hide_address">{{ organisation.address }}&nbsp;{{ organisation.address2 }}&nbsp;{{ organisation.city }}
            </h3>
        </div>

        <div class="column" v-if="(settings.list === 1 || settings.floorplan === 1) && !closed">
            <p>
                <strong>Direct beschikbaar:</strong> {{ directlyAvailable }} - <strong>Binnenkort beschikbaar:</strong> {{ soonAvailable }}
                <span v-if="settings.sizes === 1"><br><strong>Kleinste inhoud:</strong> {{ smallestSize }}m³ - <strong>Grootste inhoud:</strong> {{ largestSize }}m³</span>
            </p>
        </div>

        <div v-if="!closed">
            <slide-up-down :active="mode == 'browse'" :duration="200">
                <div class="column">
                    <div id="filterbar">
                        <div class="flex space-between">
                            <h5>Filters</h5>
                            <p class="margin0">{{ filteredRecords.length }}&nbsp;resultaten</p>
                        </div>
                        <hr>
                        <div class="flex space-between">
                            <div class="flex">
                                <div>
                                    <label for="floor">Verdieping</label>
                                    <b-select id="floor" name="floor" placeholder="Selecteer een verdieping" v-model="filters.floor" v-if="organisation.floorplan && Object.keys(organisation.floorplan).length">
                                        <option value="all" :disabled="organisation.floorplan.length <= 1 || (activeTab === 1 && settings.list === 0)">Alle verdiepingen</option>
                                        <option :value="index" v-for="(floor, index) in organisation.floorplan" :key="'floor_'+index">
                                            {{ floor.name }}
                                        </option>
                                    </b-select>
                                </div>

                                <div v-if="settings.sizes === 1">
                                    <label for="size">Grootte</label>
                                    <b-select id="size" name="size" placeholder="Selecteer een inhoud" v-model="filters.size">
                                        <option value="all">Alle groottes</option>
                                        <option :value="index" v-for="(size, index) in boxSizes" :key="'size_'+index">
                                            {{ size.size }} ({{ size.min }} - {{ size.max }}m³)
                                        </option>
                                    </b-select>
                                </div>
                            </div>

                            <b-button type="is-primary" @click="resetFilters" :disabled="!filtersChanged" class="reset">Reset</b-button>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="column">
                        <b-tabs v-model="activeTab">
                            <b-tab-item label="Lijstweergave" v-if="settings.list === 1">
                                <b-table
                                    :data="filteredRecords"
                                    :striped="true"
                                    :loading="loading"
                                    :mobile-cards="true"
                                >
                                    <template>
                                        <b-table-column v-slot="props" field="number" label="Nummer" width="100">
                                            {{ props.row.number }}
                                        </b-table-column>

                                        <!-- <b-table-column v-slot="props" field="shape" label="Shape" width="200">
                                            <svg height="100%" version="1.1" width="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="overflow: hidden; position: relative; background-image: url(&quot;http://planiteasy.test/uploads/organisations/4/floorplans/jankarssen-bg.jpg&quot;); background-size: contain; background-repeat: no-repeat;" viewBox="0 0 1351 1212" preserveAspectRatio="xMidYMid meet">
                                                <path fill="blue" stroke="#666666" :d="props.row.path" stroke-width="1" stroke-linejoin="round" class="box taken" style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0); stroke-linejoin: round;"></path>
                                            </svg>
                                        </b-table-column> -->

                                        <b-table-column v-slot="props" field="status" label="Status" width="150">
                                            <b-tag type="is-success" v-if="props.row.status === 'free'">Beschikbaar</b-tag>
                                            <b-tag type="is-warning" v-else-if="props.row.status !== 'inactive'">Binnenkort!</b-tag>
                                            <b-tag type="is-dark" v-else>Niet beschikbaar</b-tag>
                                        </b-table-column>

                                        <b-table-column v-slot="props" field="floor" label="Verdieping" width="200" v-if="organisation.floorplan && Object.keys(organisation.floorplan).length">
                                            {{ organisation.floorplan[props.row.floor].name }}
                                        </b-table-column>

                                        <b-table-column v-slot="props" field="size" width="125" label="Inhoud" v-if="settings.sizes === 1">
                                            <span v-if="props.row.size > 0 && props.row.status !== 'inactive'">
                                                {{ props.row.size }}m³

                                                <b-tooltip :label="`LxBxH: ${props.row.length ? props.row.length : '-'} x ${props.row.width ? props.row.width : '-'} x ${props.row.height ? props.row.height : '-'}m`" v-if="props.row.length && props.row.width">
                                                    <b-icon size="is-small" icon="info-circle" />
                                                </b-tooltip>
                                            </span>
                                        </b-table-column>

                                        <b-table-column v-slot="props" field="price" label="Per maand" numeric>
                                            <span v-if="props.row.price && props.row.price > 0 && settings.prices === 1 && props.row.status !== 'inactive'">
                                                &euro;&nbsp;{{ props.row.price }}
                                            </span>
                                            <span v-else-if="props.row.status !== 'inactive'">Op aanvraag</span>
                                        </b-table-column>

                                        <b-table-column v-slot="props" numeric width="100">
                                            <b-button tag="button" type="is-primary" size="is-small" @click="boxClick(props.row)" v-if="props.row.status !== 'inactive'">Interesse</b-button>
                                        </b-table-column>

                                    </template>

                                    <template #empty>
                                        <br><br>
                                        <div class="has-text-centered">Geen opslagruimtes beschikbaar<span v-show="!filtersChanged">.</span><span v-show="filtersChanged"> met deze filters.
                                            <br><br>
                                            <b-button type="is-primary" @click="resetFilters" class="reset">Reset filters</b-button>
                                        </span>
                                        <br><br>
                                        </div>
                                    </template>
                                </b-table>
                            </b-tab-item>
                            <b-tab-item label="Plattegrond" v-if="settings.floorplan === 1">
                                <div class="column floormap-wrap">
                                    <pinch-zoom wheel="false">
                                        <div id="floorplan" style="width: 100%;"></div>
                                    </pinch-zoom>

                                    <div class="boxinfo" :class="{ 'left': leftSided }" v-show="showInfo" ref="boxinfo">
                                        <div v-if="!_.isNull(hoveringObj)">
                                            <div :class="{'status': true, [hoveringObj.status.replace('+', '')]: hoveringObj.status}">
                                                {{ hoveringObj.status === 'free' ? 'Beschikbaar' : hoveringObj.status === 'inactive' ? 'Niet beschikbaar' : 'Binnenkort!' }}
                                            </div>
                                            <p class="content">
                                                <strong>Nummer:</strong>&nbsp;{{ hoveringObj.number || '-' }}<br>
                                                <span v-if="settings.sizes === 1">
                                                    <strong>Grootte:</strong>&nbsp;{{ hoveringObj.size || '-' }}m³<br>
                                                </span>
                                                <span v-show="hoveringObj.length && hoveringObj.width" v-if="settings.sizes === 1">
                                                    <strong>LxBxH:</strong>
                                                    {{ `${hoveringObj.length ? hoveringObj.length : '-'} x ${hoveringObj.width ? hoveringObj.width : '-'} x ${hoveringObj.height ? hoveringObj.height : '-'}` }}
                                                    <br>
                                                </span>
                                                <span v-if="settings.prices === 1 && hoveringObj.status !== 'inactive'">
                                                    <strong>Prijs:</strong>&nbsp;&euro;&nbsp;{{ hoveringObj.price }} p.m.<br>
                                                </span>
                                                <span v-else-if="hoveringObj.status !== 'inactive'">
                                                    <strong>Prijs:</strong>&nbsp;Op aanvraag<br>
                                                </span>

                                                <span v-if="hoveringObj.status !== 'inactive'">
                                                    <strong>Beschikbaar vanaf:</strong><br>
                                                    {{ hoveringObj.status == 'free' ? 'Direct' : hoveringObj.available_at ? moment(hoveringObj.available_at).format('DD-MM-Y') : 'N.v.t.' }}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </b-tab-item>
                        </b-tabs>
                    </div>
                </div>
            </slide-up-down>

            <slide-up-down :active="mode == 'reserve'" :duration="200" class="container">
                <div v-if="!_.isNull(favorite) || (settings.list === 0 && settings.floorplan === 0)">
                    <div class="column">
                        <hr>
                    </div>

                    <div class="column medium-5 text-right float-right">
                        <b-button type="is-dark" target="_blank" @click="backToListView" v-if="settings.list === 1 || settings.floorplan === 1">Terug naar resultaten</b-button>
                    </div>
                    <div class="column medium-7">
                        <h3 v-if="!_.isNull(favorite) || (!settings.list === 0 || !settings.floorplan === 0)">Ik heb interesse in box {{ favorite?.number }}</h3>
                        <h3 v-else>Ik heb interesse in een opslagruimte</h3>
                        <p>Laat hieronder uw gegevens achter en wij nemen zo snel mogelijk contact met u op.</p>
                    </div>

                    <div class="column">
                        <div class="row">
                            <div class="column medium-6">
                                <b-field label="Voornaam *"
                                    :message="getError(errors, 'firstname')"
                                    :type="getType(errors, 'firstname', '')"
                                >
                                    <b-input placeholder="Voornaam" v-model="customer.firstname" name="firstname" :disabled="saving"></b-input>
                                </b-field>
                            </div>
                            <div class="column medium-6">
                                <b-field label="Achternaam *"
                                    :message="getError(errors, 'lastname')"
                                    :type="getType(errors, 'lastname', '')"
                                >
                                    <span>
                                        <b-input placeholder="Achternaam" v-model="customer.lastname" name="lastname" :disabled="saving"></b-input>
                                    </span>
                                </b-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="column medium-6">
                                <b-field label="E-mailadres *"
                                    :message="getError(errors, 'email')"
                                    :type="getType(errors, 'email', '')"
                                >
                                    <b-input placeholder="email@adres.nl" type="email" name="email" v-model="customer.email" :disabled="saving"></b-input>
                                </b-field>
                            </div>
                            <div class="column medium-3">
                                <b-field label="Soort klant *"
                                    :message="getError(errors, 'type')"
                                    :type="getType(errors, 'type', '')"
                                >
                                    <b-select placeholder="Soort" expanded v-model="customer.type" :disabled="saving">
                                        <option value="normal">Particulier</option>
                                        <option value="business">Zakelijk</option>
                                        <option value="foundation">Stichting</option>
                                    </b-select>
                                </b-field>
                            </div>
                            <div class="column medium-3">
                                <b-field label="Geslacht *"
                                    :message="getError(errors, 'sex')"
                                    :type="getType(errors, 'sex', '')"
                                >
                                    <b-select placeholder="Geslacht" expanded name="sex" v-model="customer.sex" :disabled="saving">
                                        <option value="male">Man</option>
                                        <option value="female">Vrouw</option>
                                        <option value="other">Anders</option>
                                    </b-select>
                                </b-field>
                            </div>
                        </div>

                        <slide-up-down :active="customer.type == 'business' || customer.type == 'foundation'" :duration="500">
                            <div class="row">
                                <div class="column medium-12">
                                    <b-field label="Bedrijfsnaam *"
                                        :message="getError(errors, 'companyname')"
                                        :type="getType(errors, 'companyname', '')"
                                    >
                                        <b-input placeholder="Bedrijfsnaam" type="text" name="companyname" v-model="customer.companyname" :disabled="saving"></b-input>
                                    </b-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="column medium-6">
                                    <b-field label="KvK nummer *"
                                        :message="getError(errors, 'kvk')"
                                        :type="getType(errors, 'kvk', '')"
                                    >
                                        <b-input placeholder="12345678" type="text" name="kvk" v-model="customer.kvk" :disabled="saving"></b-input>
                                    </b-field>
                                </div>
                                <div class="column medium-6">
                                    <b-field label="BTW nummer *"
                                        :message="getError(errors, 'btw')"
                                        :type="getType(errors, 'btw', '')"
                                    >
                                        <b-input placeholder="NL001234567B01" type="text" name="btw" v-model="customer.btw" :disabled="saving"></b-input>
                                    </b-field>
                                </div>
                            </div>
                        </slide-up-down>

                        <div class="row">
                            <div class="column medium-6">
                                <b-field label="Telefoonnummer"
                                    :message="getError(errors, 'telephone')"
                                    :type="getType(errors, 'telephone', '')"
                                >
                                    <b-input placeholder="023-4567890" name="telephone" v-model="customer.telephone" :disabled="saving"></b-input>
                                </b-field>
                            </div>
                            <div class="column medium-6">
                                <b-field label="Mobiel"
                                    :message="getError(errors, 'mobile')"
                                    :type="getType(errors, 'mobile', '')"
                                >
                                    <b-input placeholder="06-23456789" name="mobile" v-model="customer.mobile" :disabled="saving"></b-input>
                                </b-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="column">
                                <b-field label="Land *"
                                    :message="getError(errors, 'country')"
                                    :type="getType(errors, 'country', '')"
                                >
                                    <b-select placeholder="Maak een keuze" expanded name="country" v-model="customer.country" :disabled="saving">
                                        <option value="Nederland">Nederland</option>
                                        <option value="Belgie">Belgie</option>
                                        <option value="Luxemburg">Luxemburg</option>
                                        <option value="Duitsland">Duitsland</option>
                                        <option value="Frankrijk">Frankrijk</option>
                                        <option value="Polen">Polen</option>
                                        <option value="Spanje">Spanje</option>
                                        <option value="Portugal">Portugal</option>
                                        <option value="Italië">Italië</option>
                                    </b-select>
                                </b-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="column medium-6 large-3">
                                <b-field label="Postcode *"
                                    :message="getError(errors, 'zipcode')"
                                    :type="getType(errors, 'zipcode', '')"
                                >
                                    <b-input v-model="customer.zipcode"
                                        name="zipcode"
                                        placeholder="1234 AA"
                                        :disabled="saving"
                                        @input="inputsTouched.zipcode = true"></b-input>
                                </b-field>
                            </div>
                            <div class="column medium-6 large-3 end">
                                <b-field label="Huisnummer *"
                                    :message="getError(errors, 'address2')"
                                    :type="getType(errors, 'address2', '')"
                                >
                                    <b-input v-model="customer.address2"
                                        name="address2"
                                        placeholder="123A"
                                        :disabled="saving"
                                        @input="inputsTouched.address2 = true"></b-input>
                                </b-field>
                            </div>
                            <div class="column medium-12 large-6">
                                <div class="buttons" style="margin-top: 2rem;">
                                    <b-button type="is-info"
                                        :disabled="!customer.zipcode || !customer.address2 || saving || customer.country !== 'Nederland' ||
                                                 (lastSearched.zipcode === customer.zipcode.replace(/\s+/g, '') && lastSearched.address2 === customer.address2)"
                                        @click="handleAddressSearch">
                                        Zoek adres
                                    </b-button>
                                    <span style="margin: 0px 0.5rem 0 0; line-height: 24px; vertical-align: middle; height: 30px;">of</span>
                                    <b-button type="is-dark"
                                        @click="showManualAddress = true">
                                        Handmatig invullen
                                    </b-button>
                                </div>
                            </div>
                        </div>

                        <slide-up-down :active="(mode == 'reserve' || mode == 'view') && ((showManualAddress || customer.address) && customer.country === 'Nederland' || customer.country !== 'Nederland')" :duration="300">
                            <div class="address-block" :class="{'is-filled': customer.address}">
                                <div class="row">
                                    <div class="column medium-6 large-8 paddingtop0 paddingbottom0">
                                        <b-field label="Straat *"
                                            :message="getError(errors, 'address')"
                                            :type="getType(errors, 'address', '')"
                                        >
                                            <b-input v-model="customer.address" name="address" placeholder="Voorbeeldstraat" :disabled="saving"></b-input>
                                        </b-field>
                                    </div>
                                    <div class="column medium-6 large-4 paddingtop0 paddingbottom0">
                                        <b-field label="Plaats *"
                                            :message="getError(errors, 'city')"
                                            :type="getType(errors, 'city', '')"
                                        >
                                            <b-input v-model="customer.city" name="city" placeholder="Plaatsnaam" :disabled="saving"></b-input>
                                        </b-field>
                                    </div>
                                </div>
                            </div>
                        </slide-up-down>

                        <div class="row">
                            <div class="column medium-6">
                                <b-field label="Naam rekeninghouder"
                                    :message="getError(errors, 'bankname')"
                                    :type="getType(errors, 'bankname', '')"
                                >
                                    <b-input v-model="customer.bankname" name="bankname" placeholder="Mr. Voornaam Achternaam" :disabled="saving"></b-input>
                                </b-field>
                            </div>
                            <div class="column medium-6">
                                <b-field label="Bankrekeningnummer (IBAN)"
                                    :message="getError(errors, 'banknumber')"
                                    :type="getType(errors, 'banknumber', '')"
                                >
                                    <b-input v-model="customer.banknumber" name="banknumber" placeholder="NL00BANK1234567890" :disabled="saving"></b-input>
                                </b-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="column small-3">
                                <p><small>* Verplichte velden</small></p>
                            </div>

                            <div class="column small-9 text-right paddingbottom0">
                                <b-button type="is-success" :loading="saving" @click="submitInterest">Gegevens versturen</b-button>
                            </div>

                        </div>
                    </div>
                </div>
            </slide-up-down>

            <slide-up-down :active="mode == 'finalized'" :duration="200" class="container">
                <div class="column">
                    <hr>
                </div>

                <div class="column medium-5 text-right float-right">
                    <b-button type="is-dark" target="_blank" @click="backToListView" v-if="settings.list === 1 || settings.floorplan === 1">Terug naar resultaten</b-button>
                </div>
                <div class="column medium-7">
                    <h3 v-if="!_.isNull(favorite)">Uw interesse in box {{ favorite.number }} is verstuurd!</h3>
                    <h3 v-else>Uw interesse is verstuurd!</h3>
                    <p>Wij nemen zo snel mogelijk contact met u op.</p>
                </div>
            </slide-up-down>
        </div>
        <div v-else>
            <div class="column text-center">
                <hr>
                <br>
                <h3>De online verhuur is momenteel gesloten.</h3>
                <p>
                    Wilt u meer informatie over de {{ organisation.type == 'box' ? 'opslagruimtes' : 'online verhuur' }}? Neem dan contact met ons op.
                    <br>
                    <strong>Telefoon:</strong>&nbsp;{{ organisation.telephone || '-' }}&nbsp;-&nbsp;<strong>E-mail:</strong>&nbsp;{{ settings.email || organisation.email }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import PinchZoom from 'vue-pinch-zoom'
import Raphael from '@/js/raphael.min.js'
import formvalidationMixin from '@/mixins/formvalidationMixin.js'
import addressMixin from '@/mixins/addressMixin.js'
import { load } from 'recaptcha-v3'

const defaultFilters = {
    floor: 'all',
    size: 'all'
}

export default {
    name: 'OnlineRentalPage',

    components: {
        PinchZoom
    },

    mixins: [formvalidationMixin, addressMixin],

    data () {
        return {
            settings: this.$parent.settings ? JSON.parse(this.$parent.settings) : null,
            records: this.$parent.records ? JSON.parse(this.$parent.records) : null,
            filteredRecords: false,
            organisation: this.$parent.organisation ? JSON.parse(this.$parent.organisation) : null,
            closed: this.$parent.closed ? this.$parent.closed : false,
            loading: false,
            saving: false,
            activeTab: 0,
            mode: 'browse',
            filters: {...defaultFilters},
            floorPreference: null,
            leftSided: false,
            showInfo: false,
            hoveringObj: null,
            favorite: null,
            customer: {
                country: 'Nederland', // Set default country
                type: 'normal'       // Set default type
            },
            errors: {},
            showManualAddress: false,
            inputsTouched: {
                zipcode: false,
                address2: false
            },
            lastSearched: {}
        }
    },

    created () {
        this.toDefault()

        // Parse the floorplan
        if (this.organisation.floorplan) {
            this.organisation.floorplan = JSON.parse(this.organisation.floorplan)
        }

        if (this.settings.list === 0 && this.settings.floorplan === 0) {
            this.mode = 'reserve'
        }

        this.filteredRecords = this.records
    },

    computed: {
        cssVars() {
            return {
                '--color1': this.organisation.color1,
                '--color2': this.organisation.color2
            }
        },

        filtersChanged () {
            return JSON.stringify(this.filters) !== JSON.stringify(defaultFilters);
        },

        directlyAvailable () {
            return this.records.filter((record) => {
                return record.status === 'free'
            }).length
        },

        soonAvailable () {
            return this.records.filter((record) => {
                return record.status !== 'free' && record.status !== 'inactive'
            }).length
        },

        smallestSize () {
            const sizes = this.records.map((record) => record.size).filter((size) => size != 0)
            return sizes.length > 0 ? Math.min(...sizes) : 0
        },

        largestSize () {
            return Math.max(...this.records.map((record) => record.size))
        },

        boxSizes() {
            const sizes = this.records.map((record) => record.size)

            const small = sizes.filter((size) => size < this.smallestSize + (this.largestSize - this.smallestSize) / 3)
            const medium = sizes.filter((size) => size >= this.smallestSize + (this.largestSize - this.smallestSize) / 3 && size < this.smallestSize + (this.largestSize - this.smallestSize) * 2 / 3)
            const large = sizes.filter((size) => size >= this.smallestSize + (this.largestSize - this.smallestSize) * 2 / 3)

            const boxSizes = [
                { size: 'S', min: Math.floor(Math.min(...small)), max: Math.ceil(Math.max(...small)) },
                { size: 'M', min: Math.floor(Math.min(...medium)), max: Math.ceil(Math.max(...medium)) },
                { size: 'L', min: Math.floor(Math.min(...large)), max: Math.ceil(Math.max(...large)) }
            ].filter((boxSize) => boxSize.max !== 0 && String(boxSize.min) !== 'Infinity');

            if (boxSizes.length === 1) {
                boxSizes[0].size = 'Alle'
            }

            return boxSizes
        }
    },

    methods: {
        toDefault() {
            // Select the correct tab
            if (this.settings.list ===  1) {
                this.activeTab = 0
            } else if (this.settings.floorplan === 1) {
                this.activeTab = 1
                this.filters.floor = !_.isNull(this.floorPreference) ? this.floorPreference : '0'
            }
        },

        filterRecords () {
            let records = this.records

            if (this.filters.floor === 'all') {
                // nothing
            } else {
                records = records.filter((record) => {
                    return parseInt(record.floor) === parseInt(this.filters.floor)
                })
            }

            if (this.filters.size === 'all') {
                // nothing
            } else {
                records = records.filter((record) => {
                    return parseInt(record.size) >= this.boxSizes[this.filters.size].min && parseInt(record.size) <= this.boxSizes[this.filters.size].max
                })
            }

            this.filteredRecords = records
        },

        startUpFloorPlan () {
            this.loading = true

            this.getFloorplanSize().then((image) => {
                // Clear
                document.querySelectorAll('#floorplan')[0].innerHTML = ''
                const floorplanDiv = document.querySelectorAll('#floorplan')[0]

                // this.organisation.floorplan[this.filters.floor]

                // Initialize Raphael
                let floorPlan = Raphael('floorplan', image.width, image.height)

                // Set background (floorplan)
                floorplanDiv.style.backgroundImage = 'url('+image.src+')'
                floorplanDiv.style.backgroundSize = 'contain'
                floorplanDiv.style.backgroundRepeat = 'no-repeat'

                // Set view box
                floorPlan.setViewBox(0, 0, image.width, image.height, true)
                floorPlan.setSize('100%', '100%') // responsive scaling

                // Set up boxes belonging to
                this.setUpBoxes(floorPlan).then(() => {
                    setTimeout(() => {
                        this.loading = false
                    }, 150)
                })
            })
        },

        getFloorplanSize (){
            return new Promise((resolve, reject) => {
                this.floorPlan = !_.isNull(this.organisation.floorplan) ? this.organisation.floorplan : null

                if(!this.floorPlan) return false

                const img = new Image()
                img.onload = function() {
                    resolve(this)
                }
                img.src = this.organisation.floorplan[this.filters.floor].image
            })
        },

        setUpBoxes (floorPlan){
            _.forEach(this.filteredRecords, (box) => {
                const path = floorPlan.path(box.path).attr({
                    stroke: '#666',
                    'stroke-width': 1,
                    'stroke-linejoin': 'round',
                    class: 'box '+box.status.replace('+', ''),
                    fill: box.status === 'inactive' ? '#000' : undefined
                }).click(() => {
                    if (box.status !== 'inactive') {
                        this.boxClick(box)
                    }
                }).mousemove((obj) => {
                    let widthOfBox = this.$refs.boxinfo.offsetWidth
                    this.showInfo = true

                    if(obj.view.innerWidth < 1800){
                        // Left sided infobox
                        if((obj.clientX + widthOfBox) >= obj.view.innerWidth){
                            this.hoveringObj = box
                            this.leftSided = true
                            this.$refs.boxinfo.style.top = (obj.clientY + 10) + 'px';
                            this.$refs.boxinfo.style.left = (obj.clientX - widthOfBox) + 'px';
                        } else {
                            this.hoveringObj = box
                            this.leftSided = false
                            this.$refs.boxinfo.style.top = (obj.clientY + 10) + 'px';
                            this.$refs.boxinfo.style.left = (obj.clientX + 10) + 'px';
                        }
                    } else {
                        this.hoveringObj = box
                        this.leftSided = false
                        this.$refs.boxinfo.style.top = (obj.clientY + 10) + 'px';
                        this.$refs.boxinfo.style.left = (obj.clientX + 10) + 'px';
                    }
                })

                path.mouseout(() => {
                    this.showInfo = false
                    this.hoveringObj = null
                })

                // Add text (box number) to box
                this.addTextToPath(path, box)
            })

            return new Promise((resolve) => {
                resolve()
            })
        },

        boxClick (box){
            this.favorite = {
                id: box.id,
                number: box.number
            }

            switch (this.settings.finalize) {
                case 'finalize':
                default:
                    this.mode = 'reserve'
                break
                // TODO; add more cases in the future
            }
        },

        backToListView () {
            this.mode = 'browse'
            this.favorite = null
            this.errors = {}
        },

        addTextToPath (path, box){
            let textattr = { 'font-size': 8, stroke: 'none', 'font-family': 'Arial,Helvetica,sans-serif', 'font-weight': 400 }
            let bbox = path.getBBox()
            let textObj = path.paper.text(bbox.x + bbox.width / 2, bbox.y + bbox.height / 2, box.number).attr( textattr );

            // Initialize click action
            textObj.click(() => {
                this.boxClick(box)
            })

            return textObj
        },

        resetFilters () {
            this.filters = {...defaultFilters}
            this.toDefault()
        },

        async submitInterest () {
            this.saving = true

            try {
                let payload = {...this.customer}

                const recaptchaToken = await this.getRecaptchaToken()
                payload.recaptcha = recaptchaToken

                const response = await axios.post(`/online-huren/${this.settings.url}/${this.favorite?.id || 0}`, payload)

                if (response.data === 'success') {
                    this.mode = 'finalized'
                    this.customer = {}
                    this.saving = false
                }
            } catch (error) {
                this.saving = false
                this.errors = error.response.data.errors
            }
        },

        getRecaptchaToken() {
            return new Promise((resolve, reject) => {
                const siteKey = document.querySelector('meta[name="recaptcha-sitekey"]').getAttribute('content')

                load(siteKey, { autoHideBadge: true }).then((recaptcha) => {
                    recaptcha.execute('rentalinterest').then((token) => {
                        resolve(token)
                    }).catch((error) => {
                        reject(error)
                    })
                })
            })
        },

        handleAddressSearch() {
            const siteKey = document.querySelector('meta[name="recaptcha-sitekey"]').getAttribute('content')
            this.searchAddress('online-rental', siteKey)
        },
    },

    _watch: {
        activeTab(newValue) {
            if (newValue === 1) {
                this.filters.floor = !_.isNull(this.floorPreference) ? this.floorPreference : '0'
            }
        },

        filters: {
            handler() {
                this.filterRecords()

                if (this.filters.floor === 'all' && this.activeTab === 1) {
                    this.activeTab = 0
                }

                if (this.filters.floor !== 'all' && this.activeTab === 1) {
                    this.floorPreference = this.filters.floor
                    this.startUpFloorPlan()
                }

                if (this.filters.size !== 'all') {
                    // this.filteredRecords = filter(this.filteredRecords, { size: parseInt(this.filters.size) })
                    this.filteredRecords = this.filteredRecords.filter((record) => {
                        return record.size >= this.boxSizes[this.filters.size].min && record.size <= this.boxSizes[this.filters.size].max
                    })
                }
            }, deep: true
        }
    },
    get watch() {
        return this._watch
    },
    set watch(value) {
        this._watch = value
    },
}
</script>

<style lang="scss" scoped>
$color1: var(--color1);
$color2: var(--color2);

#online-rental {
    .button.is-primary {
        background-color: $color1;
    }
    .b-tooltip.is-primary {
        color: $color1;
    }
}

.address-block {
    background-color: #f5f5f5;
    padding: 1rem;
    border-radius: 4px;
    margin: 1rem 0;
    transition: all 0.3s ease;
}

.address-block.is-filled {
    background-color: #f0f7ff;
    border: 1px solid #dbedff;
}
</style>
